var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"page-member-add"}},[_c('vx-card',{staticClass:"mb-base",attrs:{"title":"회원 상세 정보"}},[_c('member-add-form',{staticClass:"mt-4"})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }